/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ehckhYnyDHgCBbV47m9bkf
// Component: 1T4UNMYLSC7u

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { Tooltip } from "../../components/plexus/Tooltip"; // plasmic-import: EBbuUzYSewBk/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_pricing.css"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectcss
import sty from "./PlasmicHoverableIcon.module.css"; // plasmic-import: 1T4UNMYLSC7u/css

import InformationSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__InformationSvg"; // plasmic-import: hqBNVBJWB/icon

createPlasmicElementProxy;

export type PlasmicHoverableIcon__VariantMembers = {
  above: "above";
  white: "white";
};
export type PlasmicHoverableIcon__VariantsArgs = {
  above?: SingleBooleanChoiceArg<"above">;
  white?: SingleBooleanChoiceArg<"white">;
};
type VariantPropType = keyof PlasmicHoverableIcon__VariantsArgs;
export const PlasmicHoverableIcon__VariantProps = new Array<VariantPropType>(
  "above",
  "white"
);

export type PlasmicHoverableIcon__ArgsType = {
  popover?: React.ReactNode;
  forceOverlay?: boolean;
};
type ArgPropType = keyof PlasmicHoverableIcon__ArgsType;
export const PlasmicHoverableIcon__ArgProps = new Array<ArgPropType>(
  "popover",
  "forceOverlay"
);

export type PlasmicHoverableIcon__OverridesType = {
  root?: Flex__<typeof Tooltip>;
  svg?: Flex__<"svg">;
};

export interface DefaultHoverableIconProps {
  popover?: React.ReactNode;
  forceOverlay?: boolean;
  above?: SingleBooleanChoiceArg<"above">;
  white?: SingleBooleanChoiceArg<"white">;
  className?: string;
}

const $$ = {};

function PlasmicHoverableIcon__RenderFunc(props: {
  variants: PlasmicHoverableIcon__VariantsArgs;
  args: PlasmicHoverableIcon__ArgsType;
  overrides: PlasmicHoverableIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          forceOverlay: false,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "above",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.above,
      },
      {
        path: "white",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.white,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Tooltip
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.root)}
      content={renderPlasmicSlot({
        defaultContents: "Some description",
        value: args.popover,
        className: classNames(sty.slotTargetPopover, {
          [sty.slotTargetPopoverabove]: hasVariant($state, "above", "above"),
        }),
      })}
      trigger={
        <InformationSvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames("all", sty.svg, {
            [sty.svgwhite]: hasVariant($state, "white", "white"),
          })}
          role={"img"}
        />
      }
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof Tooltip;
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHoverableIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHoverableIcon__VariantsArgs;
    args?: PlasmicHoverableIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicHoverableIcon__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHoverableIcon__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHoverableIcon__ArgProps,
          internalVariantPropNames: PlasmicHoverableIcon__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicHoverableIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHoverableIcon";
  } else {
    func.displayName = `PlasmicHoverableIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicHoverableIcon = Object.assign(
  // Top-level PlasmicHoverableIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicHoverableIcon
    internalVariantProps: PlasmicHoverableIcon__VariantProps,
    internalArgProps: PlasmicHoverableIcon__ArgProps,
  }
);

export default PlasmicHoverableIcon;
/* prettier-ignore-end */
